import { render, staticRenderFns } from "./buttonAdd.vue?vue&type=template&id=70cf850b"
import script from "./buttonAdd.vue?vue&type=script&lang=js"
export * from "./buttonAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports